import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const GoogleBusinessProfileNotVerifiedBanner = () => {
  const { t } = useTranslation('schedule');
  return (
    <section css={bannerStyles}>
      <Text>
        {t(
          'Your Google Business Profile needs to be verified before you can add a booking link. Please verify your Google Business Profile to proceed.'
        )}
      </Text>
    </section>
  );
};

const bannerStyles = css({
  padding: theme.spacing(2),
  backgroundColor: theme.colors.warning5,
  borderRadius: theme.borderRadius.medium,
  border: `1px solid ${theme.colors.warning50}`,
  marginTop: theme.spacing(2),
});
